import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { LoadingComponent } from './loading.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [BrowserAnimationsModule, NgxSpinnerModule, TranslateModule],
  declarations: [LoadingComponent],
  exports: [LoadingComponent],
})
export class LoadingModule {}
